export default "__VITE_ASSET__BWiFIwoj__"